import { FileValidationRule } from './file-validation-rule';

export class FilesizeValidationRule implements FileValidationRule {
    private readonly MAX_FILE_SIZE = 1024 * 1024 * 7.5;

    public readonly errorKey = 'maxDataSizeForOneDocument';


    public validate(file: File): boolean {
        return file.size <= this.MAX_FILE_SIZE;
    }
}
